import { FunnelStage, SCREEN_CATALOG, ScreenKey } from "analytics/catalog/screens";

export type CommonEventProps = {
  page_name: string | null;
  page_url: string | null;
  business_id: string | null;
  user_id: string | null;
  user_email: string | null;
  funnel_stage: FunnelStage;
  campaign_id: string | null;
  plan_type: string | null;
  currency: string | null;
  compensation_type: string | null;
  source: string | null;
  medium: string | null;
};

type BuildCommonEventPropsInput = {
  screenKey: ScreenKey;
  pathname: string;
  search: string;
  businessId?: string | null;
  userId?: string | null;
  userEmail?: string | null;
  campaignId?: string | null;
  planType?: string | null;
  currency?: string | null;
  compensationType?: string | null;
  pageNameOverride?: string | null;
  funnelStageOverride?: FunnelStage;
};

const readQueryParam = (params: URLSearchParams, key: string): string | null => {
  const value = params.get(key);
  if (!value) {
    return null;
  }

  const trimmedValue = value.trim();
  return trimmedValue.length > 0 ? trimmedValue : null;
};

const buildPageUrl = (pathname: string, search: string): string => {
  const hasWindowLocation =
    typeof window !== "undefined" &&
    typeof window.location !== "undefined" &&
    Boolean(window.location.origin);

  if (!hasWindowLocation) {
    return `${pathname}${search}`;
  }

  return `${window.location.origin}${pathname}${search}`;
};

export const buildCommonEventProps = (
  input: BuildCommonEventPropsInput,
): CommonEventProps => {
  const screenConfig = SCREEN_CATALOG[input.screenKey];
  const params = new URLSearchParams(input.search);

  return {
    page_name: input.pageNameOverride ?? screenConfig.pageName ?? null,
    page_url: buildPageUrl(input.pathname, input.search),
    business_id: input.businessId ?? null,
    user_id: input.userId ?? null,
    user_email: input.userEmail ?? null,
    funnel_stage: input.funnelStageOverride ?? screenConfig.funnelStage,
    campaign_id: input.campaignId ?? null,
    plan_type: input.planType ?? null,
    currency: input.currency ?? null,
    compensation_type: input.compensationType ?? null,
    source: readQueryParam(params, "utm_source"),
    medium: readQueryParam(params, "utm_medium"),
  };
};
